import { fetchFinance } from "utils/api";
import { getAgent } from "utils/utils";

export const queryList = async (params) => {
  return await fetchFinance("/merchant/list", {
    sort: "id,desc",
    ...params,
  });
};

export const createDebitApplication = async (params) => {
  const agent = getAgent();
  return await fetchFinance("/action", {
    action: "addDebitApply",
    applicant: agent.email,
    ...params,
  });
};

export const exportCsv = async (params) => {
  return await fetchFinance("/merchant/exportAll", {
    ...params,
  });
};
